import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-problem-solution-result',
  imports: [SectionWrapperComponent],
  templateUrl: './problem-solution-result.component.html',
  styleUrl: './problem-solution-result.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProblemSolutionResultComponent {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly featureFlags = inject(FeatureFlagService);

  readonly section = computed(() => {
    this.featureFlags.flags();
    const data = this.siteConfig.psr();
    if (!data) {
      return null;
    }
    return { ...data, items: this.featureFlags.filterItems(data.items) };
  });
}
